import styled from 'styled-components'
import { theme, progressiveBreakpoints } from '../../constants/theme'

const Root = styled.div`
  h2 {
    margin-bottom: 1rem;
  }

  p {
    color: ${theme.colors.fonts.lightGrey};
    font-size: 1rem;
    line-height: 1.25;
    margin-bottom: 1rem;
  }
`

const Columns = styled.div`
  padding: 1.25rem;
  @media ${progressiveBreakpoints.desktopSmall} {
    display: flex;
    justify-content: space-between;
    padding: 2.5rem;
    > * {
      max-width: 402px;
    }

    ${(props) =>
      props.reverse &&
      `
      flex-direction: row-reverse;
    `}
  }
`

const AnimationWrapper = styled.div`
  position: relative;

  @media ${progressiveBreakpoints.desktopSmall} {
    width: 266px;
    height: 266px;
  }
`

export { Root, Columns, AnimationWrapper }
